import EmptyWheelItem from "../EmptyWheelItem";
import { WheelItemProps } from "./types";

const WheelItem = <T extends any>({
	item,
	width,
	height,
	borderRadius,
	index,
	renderItem,
}: WheelItemProps<T>) => {
	return (
		<>
			{/* Likely cheaper to just keep this always rendered */}
			<EmptyWheelItem width={width} height={height} borderRadius={borderRadius} />
			{renderItem?.({
				item,
				width,
				height,
				borderRadius,
				index,
			})}
		</>
	);
};
export default WheelItem;
